const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "table.superadmin_raw_colors/SET_TABLE_PARAMS":
            return {
                ...state,
                ...action.params
            };
        case "table.superadmin_raw_colors/LIST_RAW_COLORS_SUCCESS":
            return {
                ...state,
                data: action.response.data,
                filters: action.response.filters,
                ...action.response.pagination
            };
        default:
            return state;
    }
}
